export function customScroll() {
    $(document).ready(function () {
        if ($(window).width() < 768) {
            jcf.setOptions("Scrollable", {
                handleResize: false,
                alwaysShowScrollbars: false,
                alwaysPreventMouseWheel: true
            });
            jcf.replaceAll();

        }
    });
    $(window).on("resize", function () {
        if ($(window).width() < 768) {
            jcf.replaceAll();
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/customScroll.js